import React, { Component, Fragment } from 'react';
import {
  Button,
  Col,
  DropdownMenu,
  DropdownToggle,
  Row,
  Tooltip,
  UncontrolledDropdown,
  DropdownItem,
  Label,
  Input,
  FormGroup
} from 'reactstrap';
import PolicyModal from './PolicyModal/PolicyModal';
import axiosInstance from '@src/axios-instance';
import PolicyView from './PolicyView/PolicyView';
import ConfirmModal from '@components/ConfirmModal/ConfirmModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Auth from '@src/components/Elements/Auth/Auth';
import isAllowed from '@src/auth';

class Policies extends Component {
  constructor(props) {
    super(props);
    this.toggleModal = this.toggleModal.bind(this);
    this.state = {
      modalNewActive: false,
      confirmModalActive: false,
      copyModalActive: false,
      activateModalActive: false,
      tooltipOpen: false,
      carriers: [],
      activePolicies: [],
      futurePolicies: [],
      activeEntity: {},
      activeVersion: 'active',
      loading: false,
      defaultRemarks: false
    };
    this.getCarriers();
    this.getPolicies();
  }

  setPoliciesState = data => {
    const active = data.filter(x => x.status === 'active');
    const pending = data.filter(x => x.status === 'pending');
    this.setState({
      activePolicies: active.length > 0 ? active[0] : {},
      futurePolicies: pending.length > 0 ? pending[0] : {}
    });
    this.props.getEntity();
  };

  getPolicies = () => {
    axiosInstance()
      .get('/policies.json', {
        params: { association_id: this.props.entityId }
      })
      .then(response => {
        this.setPoliciesState(response.data);
      });
  };

  updatePolicyOptions = (setId, postData) => {
    if (isAllowed({ action: 'Associations::editPolicies' })) {
      this.setState({ loading: true });
      axiosInstance()
        .post(`/policies/update-options/${setId}.json`, postData)
        .then(response => {
          this.setPoliciesState(response.data);
          this.setState({ loading: false });
        });
    }
  };

  copyPolicies = () => {
    this.setState({ loading: true });
    axiosInstance()
      .get('/policies/copy-current-year.json', {
        params: { association_id: this.props.entityId }
      })
      .then(response => {
        this.setState({
          copyModalActive: false
        });
        this.setPoliciesState(response.data);
        this.setState({ loading: false });
      });
  };

  activatePolicies = () => {
    this.setState({ loading: true });
    axiosInstance()
      .get('/policies/activate.json', {
        params: { association_id: this.props.entityId }
      })
      .then(response => {
        this.setState({
          activateModalActive: false
        });
        this.setPoliciesState(response.data);
        this.setState({ loading: false });
      });
  };

  getCarriers = () => {
    axiosInstance()
      .get('/carriers/full-list.json')
      .then(response => {
        this.setState({
          carriers: response.data
        });
      });
  };

  savePolicy = postData => {
    postData.association_id = this.props.entityId;

    this.setState({ loading: true });
    if (this.state.activeEntity.id !== undefined) {
      axiosInstance()
        .put(`/policies/${this.state.activeEntity.id}.json`, postData)
        .then(response => {
          this.setState({
            modalNewActive: false,
            activeEntity: {}
          });
          this.setPoliciesState(response.data);
          this.setState({ loading: false });
        });
    } else {
      postData.active_version = this.state.activeVersion;
      this.setState({ loading: true });
      axiosInstance()
        .post('/policies.json', postData)
        .then(response => {
          this.setState({
            modalNewActive: false,
            activeEntity: {}
          });
          this.setPoliciesState(response.data);
          this.setState({ loading: false });
        });
    }
  };

  deletePolicy = policyId => {
    this.setState({ loading: true });
    axiosInstance()
      .delete(`/policies/${policyId}.json`)
      .then(response => {
        this.setState({
          confirmModalActive: false,
          activeEntity: {}
        });
        this.setPoliciesState(response.data);
        this.setState({ loading: false });
      });
  };

  toggleModal = (modalType, entity, activeVersion) => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType],
      activeEntity: entity !== undefined ? entity : {},
      activeVersion: activeVersion !== undefined ? activeVersion : 'active'
    }));
  };

  render = () => {
    return (
      <Fragment>
        {this.state.loading && (
          <ProgressBox text={'Loading ...'} loader={'transparent-background'} />
        )}
        <Row>
          <Col>
            <h3>
              Current Year
              <Auth action={'Associations::editPolicies'}>
                <Button
                  color={'secondary'}
                  className={'float-right'}
                  size={'sm'}
                  onClick={() =>
                    this.toggleModal('modalNewActive', {}, 'active')
                  }
                >
                  Create New Policy
                </Button>
              </Auth>
            </h3>
          </Col>
        </Row>
        {this.state.activePolicies.id !== undefined &&
          this.state.activePolicies.master_policies.length > 0 && (
            <React.Fragment>
              <Row
                onClick={() =>
                  this.state.defaultRemarks === this.state.activePolicies.id
                    ? null
                    : this.setState({
                        defaultRemarks: this.state.activePolicies.id
                      })
                }
                className={'pointer mt-2'}
              >
                <Col>
                  <h5>Default Remarks</h5>
                  {this.state.defaultRemarks !== this.state.activePolicies.id &&
                  !this.props.loading ? (
                    <p className={'pointer'} style={{ minHeight: '50px' }}>
                      {this.state.activePolicies.remarks}
                    </p>
                  ) : (
                    <textarea
                      className={'defaultRemarks form-control'}
                      onBlur={e => {
                        this.updatePolicyOptions(this.state.activePolicies.id, {
                          remarks: e.currentTarget.value
                        });
                        this.setState({
                          defaultRemarks: false
                        });
                      }}
                      defaultValue={this.state.activePolicies.remarks}
                      rows={7}
                      maxLength={2000}
                    />
                  )}
                </Col>
              </Row>
              <hr className={'mb-3 mt-1'} />
              <Row>
                <Col>
                  <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
                    <Label check>
                      <Input
                        style={{ top: '5px' }}
                        type="checkbox"
                        checked={this.state.activePolicies.perils_insured === 1}
                        onChange={e =>
                          this.updatePolicyOptions(
                            this.state.activePolicies.id,
                            {
                              perils_insured: e.currentTarget.checked ? 1 : 0
                            }
                          )
                        }
                      />{' '}
                      Perils Insured (All Risk)
                    </Label>
                  </FormGroup>
                  <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
                    <Label check>
                      <Input
                        style={{ top: '5px' }}
                        type="checkbox"
                        checked={this.state.activePolicies.basic_form === 1}
                        onChange={e =>
                          this.updatePolicyOptions(
                            this.state.activePolicies.id,
                            {
                              basic_form: e.currentTarget.checked ? 1 : 0
                            }
                          )
                        }
                      />{' '}
                      Basic Form
                    </Label>
                  </FormGroup>
                  <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
                    <Label check>
                      <Input
                        style={{ top: '5px' }}
                        type="checkbox"
                        checked={this.state.activePolicies.broad_form === 1}
                        onChange={e =>
                          this.updatePolicyOptions(
                            this.state.activePolicies.id,
                            {
                              broad_form: e.currentTarget.checked ? 1 : 0
                            }
                          )
                        }
                      />{' '}
                      Broad Form
                    </Label>
                  </FormGroup>
                  <FormGroup check className={'pb-3 pt-2 float-left'}>
                    <Label check>
                      <Input
                        style={{ top: '5px' }}
                        type="checkbox"
                        checked={this.state.activePolicies.special_form === 1}
                        onChange={e =>
                          this.updatePolicyOptions(
                            this.state.activePolicies.id,
                            {
                              special_form: e.currentTarget.checked ? 1 : 0
                            }
                          )
                        }
                      />{' '}
                      Special Form
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <ol type={'A'}>
                    {this.state.activePolicies.master_policies.map(item => (
                      <li key={`policy-${item.id}`}>
                        <PolicyView
                          entity={item}
                          onDelete={entity =>
                            this.toggleModal('confirmModalActive', entity)
                          }
                          onEdit={entity =>
                            this.toggleModal('modalNewActive', entity)
                          }
                        />
                      </li>
                    ))}
                  </ol>
                </Col>
              </Row>
            </React.Fragment>
          )}

        <hr className={'my-4'} />
        <Row>
          <Col>
            <h3>
              Coming Year (Renewal)
              <Auth action={'Associations::editPolicies'}>
                <UncontrolledDropdown
                  className={'float-right d-flex'}
                  size={'sm'}
                >
                  <DropdownToggle caret className={'btn-sm'}>
                    Create Renewal Policy
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem
                      disabled={this.state.activePolicies.id === undefined}
                      onClick={
                        this.state.activePolicies.id === undefined
                          ? null
                          : () => this.toggleModal('copyModalActive')
                      }
                    >
                      Copy Current Year’s Policies
                    </DropdownItem>
                    <DropdownItem
                      onClick={() =>
                        this.toggleModal('modalNewActive', {}, 'pending')
                      }
                    >
                      Create New
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <Button
                  color={'secondary'}
                  className={'float-right mr-2'}
                  size={'sm'}
                  disabled={this.state.futurePolicies.id === undefined}
                  onClick={
                    this.state.futurePolicies.id === undefined
                      ? null
                      : () => this.toggleModal('activateModalActive')
                  }
                >
                  Archive Current Year Policy{'  '}
                  <span id={'tooltip-box'}>
                    <FontAwesomeIcon icon={['fas', 'question-circle']} />
                  </span>
                </Button>
                <Tooltip
                  placement="left"
                  isOpen={this.state.tooltipOpen}
                  target="tooltip-box"
                  toggle={() => this.toggleModal('tooltipOpen')}
                >
                  Upon activation, Coming Year (Renewal) policies will be turned
                  into Current Year’s policies. This association’s current year
                  policies will be deleted.
                </Tooltip>
              </Auth>
            </h3>
          </Col>
        </Row>
        {this.state.futurePolicies.id !== undefined &&
          this.state.futurePolicies.master_policies.length > 0 && (
            <React.Fragment>
              <Row
                onClick={() =>
                  this.state.defaultRemarks === this.state.futurePolicies.id
                    ? null
                    : this.setState({
                        defaultRemarks: this.state.futurePolicies.id
                      })
                }
                className={'pointer mt-2'}
              >
                <Col>
                  <h5>Default Remarks</h5>
                  {this.state.defaultRemarks !== this.state.futurePolicies.id &&
                  !this.props.loading ? (
                    <p className={'pointer'} style={{ minHeight: '50px' }}>
                      {this.state.futurePolicies.remarks}
                    </p>
                  ) : (
                    <textarea
                      className={'defaultRemarks form-control'}
                      onBlur={e => {
                        this.updatePolicyOptions(this.state.futurePolicies.id, {
                          remarks: e.currentTarget.value
                        });
                        this.setState({
                          defaultRemarks: false
                        });
                      }}
                      defaultValue={this.state.futurePolicies.remarks}
                      rows={7}
                      maxLength={2000}
                    />
                  )}
                </Col>
              </Row>
              <hr className={'mb-3 mt-1'} />
              <Row>
                <Col>
                  <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
                    <Label check>
                      <Input
                        style={{ top: '5px' }}
                        type="checkbox"
                        checked={this.state.futurePolicies.perils_insured === 1}
                        onChange={e =>
                          this.updatePolicyOptions(
                            this.state.futurePolicies.id,
                            {
                              perils_insured: e.currentTarget.checked ? 1 : 0
                            }
                          )
                        }
                      />{' '}
                      Perils Insured (All Risk)
                    </Label>
                  </FormGroup>
                  <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
                    <Label check>
                      <Input
                        style={{ top: '5px' }}
                        type="checkbox"
                        checked={this.state.futurePolicies.basic_form === 1}
                        onChange={e =>
                          this.updatePolicyOptions(
                            this.state.futurePolicies.id,
                            {
                              basic_form: e.currentTarget.checked ? 1 : 0
                            }
                          )
                        }
                      />{' '}
                      Basic Form
                    </Label>
                  </FormGroup>
                  <FormGroup check className={'pb-3 pt-2 float-left mr-3'}>
                    <Label check>
                      <Input
                        style={{ top: '5px' }}
                        type="checkbox"
                        checked={this.state.futurePolicies.broad_form === 1}
                        onChange={e =>
                          this.updatePolicyOptions(
                            this.state.futurePolicies.id,
                            {
                              broad_form: e.currentTarget.checked ? 1 : 0
                            }
                          )
                        }
                      />{' '}
                      Broad Form
                    </Label>
                  </FormGroup>
                  <FormGroup check className={'pb-3 pt-2 float-left'}>
                    <Label check>
                      <Input
                        style={{ top: '5px' }}
                        type="checkbox"
                        checked={this.state.futurePolicies.special_form === 1}
                        onChange={e =>
                          this.updatePolicyOptions(
                            this.state.futurePolicies.id,
                            {
                              special_form: e.currentTarget.checked ? 1 : 0
                            }
                          )
                        }
                      />{' '}
                      Special Form
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <ol type={'A'}>
                    {this.state.futurePolicies.master_policies.map(item => (
                      <li key={`policy-${item.id}`}>
                        <PolicyView
                          entity={item}
                          onDelete={entity =>
                            this.toggleModal('confirmModalActive', entity)
                          }
                          onEdit={entity =>
                            this.toggleModal('modalNewActive', entity)
                          }
                        />
                      </li>
                    ))}
                  </ol>
                </Col>
              </Row>
            </React.Fragment>
          )}
        {this.state.modalNewActive && (
          <PolicyModal
            entity={this.state.activeEntity}
            isActive={this.state.modalNewActive}
            toggle={() => this.toggleModal('modalNewActive')}
            carriers={this.state.carriers}
            savePolicy={this.savePolicy}
          />
        )}
        <ConfirmModal
          isActive={this.state.confirmModalActive}
          toggle={() => this.toggleModal('confirmModalActive')}
          body={
            'Please confirm before deleting this policy record. This data cannot be recovered.'
          }
          confirmLabel={'Yes, delete this policy'}
          confirmAction={() => this.deletePolicy(this.state.activeEntity.id)}
        />
        <ConfirmModal
          isActive={this.state.copyModalActive}
          toggle={() => this.toggleModal('copyModalActive')}
          title={'Copy Current Year’s Policies'}
          body={
            'Please confirm that that you’r like to copy all of current year’s policies for the Coming Year. You' +
            ' cannot undo this action. Details of the policies can be modified later. '
          }
          confirmLabel={'Yes, copy current year’s policies'}
          confirmAction={this.copyPolicies}
        />
        <ConfirmModal
          isActive={this.state.activateModalActive}
          toggle={() => this.toggleModal('activateModalActive')}
          title={'Confirm Renewal'}
          body={
            'Upon renewal, Coming Year (Renewal) policies will be turned into Current Year’s policies. This' +
            ' association’s current year policies will be archived. Please confirm before proceeding forward.'
          }
          confirmLabel={'Yes, renew policies.'}
          confirmAction={this.activatePolicies}
        />
      </Fragment>
    );
  };
}

export default Policies;
